import * as ZapparThree from '@zappar/zappar-threejs'
import * as THREE from 'three'

import Shark from '..'
import Experience from '../..'

import defaultTargetImage from '../../../assets/tracker/NoSharkTarget.zpt'

import LoadingManager from '../../Utils/LoadingManager'
// import Stability from './Stability'

export default class ImageTracker {
  static instance: ImageTracker

  private experience = new Experience()
  private shark!: Shark
  // public stability!: Stability

  private helper1!: THREE.Mesh
  private helper2!: THREE.Mesh

  private frustum = new THREE.Frustum()

  public imageTracker!: ZapparThree.ImageTracker
  public imageTrackerGroup!: ZapparThree.ImageAnchorGroup

  private targetSeen = false
  private isTriggered = false

  private isDefault = true;

 // public target: any;

  private interval: any



  constructor(shark: Shark) {
    this.shark = shark
    //this.setTracker()
    //this.start()
  }

  private showHelpers() {
    this.helper1.visible = true
    this.helper2.visible = true
  }
  private hideHelpers() {
    this.helper1.visible = false
    this.helper2.visible = false
  }

  private createTrackerHelpers() {
    this.helper1 = new THREE.Mesh(new THREE.PlaneBufferGeometry(0.1, 0.1, 1),new THREE.MeshBasicMaterial({ color: 'red' }))
    this.helper2 = this.helper1.clone()
    if(this.isDefault){
      this.helper1.position.set(0, 0, 0.5)
      this.helper2.position.set(1.5, 0, 0.5)
    }
    else{
      this.helper1.position.set(-0.3, -0.65, 0)
      this.helper2.position.set(0.9, -0.65,0)
    }

    
    

    this.hideHelpers()

    this.imageTrackerGroup.add(this.helper1, this.helper2);
  }

  public start() {
    
    // TARGET SEEN
    this.imageTracker.onVisible.bind(() => {
      //this.showHelpers()

      this.interval = setInterval(() => {
        const fov = this.isInFOV(this.helper1, this.helper2)

        if (fov) {
          this.targetSeen = true

          // lookForMsg.innerText = 'Please stay still'

          // if (this.stability.isStable) {
          // lookForMsg.innerText = 'Shark found!'

          if (!this.isTriggered) {
            this.updateGUI('none')
            this.isTriggered = true
            this.experience.eventEmitter.emit('sharkSeenEvent', true)
          }
          // }
          //  else {
          //   this.shark.model.scene.visible = true
          // }
          // } else {
          //   // lookForMsg.innerText = 'NOT STABLE!'
          // }
        } else {
          // this.updateGUI('block')
          this.targetSeen = false
          // this.stability.frameCounter = 0
          // this.stability.isStable = false
          // this.shark.model.scene.visible = false
          // lookForMsg.innerText = 'looking for a 🦈...'
        }
      }, 100)

      // this.experience.eventEmitter.emit('sharkSeenEvent', true)
      // if (!this.targetSeen) this.targetSeen = true
      // if (this.experience.navigationManager.step < 1) this.updateGUI('none')
    })

    // TARGET NOT SEEN
    this.imageTracker.onNotVisible.bind(() => {
      clearInterval(this.interval)

      this.hideHelpers()

      this.targetSeen = false
      // this.stability.frameCounter = 0

      if (this.isTriggered) {
        this.isTriggered = false
        // this.stability.isStable = false
        this.experience.eventEmitter.emit('sharkSeenEvent', false)
      }
    })
  }

  private isInFOV(object1: THREE.Object3D, object2: THREE.Object3D) {
    this.experience.camera.zapparCamera.updateMatrix() // make sure camera's local matrix is updated
    this.experience.camera.zapparCamera.updateMatrixWorld() // make sure camera's world matrix is updated

    this.helper1.updateMatrix() // make sure plane's local matrix is updated
    this.helper2.updateMatrixWorld() // make sure plane's world matrix is updated

    this.frustum.setFromProjectionMatrix(
      new THREE.Matrix4().multiplyMatrices(
        this.experience.camera.zapparCamera.projectionMatrix,
        this.experience.camera.zapparCamera.matrixWorldInverse
      )
    )

    const result =
      this.frustum.intersectsObject(object1) &&
      this.frustum.intersectsObject(object2)
    return result
  }

  private updateGUI(display: string) {
    // let phonePrompt = document.getElementById('phone-prompt') as HTMLDivElement
    let phonePrompt = document.getElementById(
      'outline-container'
    ) as HTMLDivElement

    if (phonePrompt) {
      phonePrompt.style.display = display === 'none' ? 'none' : 'flex'
      phonePrompt.style.opacity = display === 'none' ? '0' : '1'
    }

    const cameraBtn = document.getElementById('camera-btn') as HTMLImageElement
    const handPrompt = document.getElementById(
      'hand-prompt'
    ) as HTMLImageElement

    const isHidden = this.experience.navigationManager.step === 0

    if (cameraBtn && handPrompt && isHidden) {
      cameraBtn.style.display = display === 'none' ? 'block' : 'none'
      cameraBtn.style.opacity = display === 'none' ? '1' : '0'

      handPrompt.style.display = display === 'none' ? 'block' : 'none'
      handPrompt.style.opacity = display === 'none' ? '1' : '0'
    }
  }



 

  public setTracker(isdefault : boolean, country : string, code : string) {
    this.isDefault = isdefault;
  

  
        if(this.isDefault){
          this.imageTracker = new ZapparThree.ImageTrackerLoader(LoadingManager).load(defaultTargetImage);
        }
        else{
          let targetZptSrc  = 'https://ddg67ecygv8rc.cloudfront.net/Crayola/NewTargets/' + country + '/target' + code + '.zpt'
          this.imageTracker = new ZapparThree.ImageTrackerLoader(LoadingManager).load(targetZptSrc);
        }

    this.imageTrackerGroup = new ZapparThree.ImageAnchorGroup(
      this.experience.camera.zapparCamera,
      this.imageTracker
    )

    // Add our image tracker group into the ThreeJS scene
    this.experience.scene.add(this.imageTrackerGroup)

    // this.stability = new Stability(this.imageTrackerGroup, this.shark)

    this.createTrackerHelpers()
    this.start();
  }

  public clear() {
    clearInterval(this.interval)
    // this.stability.frameCounter = 0
    // this.stability.isStable = false
    this.targetSeen = false
    this.isTriggered = false
  }

  public update() {
    if (this.targetSeen) {
      // this.stability.update()
      if(this.isDefault){
        this.shark.textureBuilderDefault.update()
      }
      else{
        this.shark.textureBuilder.update()
      }
    }
  }
}
